module.exports = __webpack_public_path__ + "fc434ccd.svg";